import React, { createContext, useContext, useState, useCallback } from 'react';
import { isEqual, isFunction } from 'lodash';
import { initialFilter, initialDeliver } from './DeliveriesUIHelpers';

const DeliveriesUIContext = createContext();

export function useDeliveriesUIContext() {
  return useContext(DeliveriesUIContext);
}

export const DeliverUIConsumer = DeliveriesUIContext.Consumer;

export function DeliveriesUIProvider({ DeliveriesUIEvents, children }) {
  const [createdDeliver, setCreatedDeliverBase] = useState(initialDeliver);
  const [deliverForView, setDeliverForViewBase] = useState(initialDeliver);
  const [queryParams, setQueryParamsBase] = useState(initialFilter);

  const setQueryParams = useCallback(
    (nextQueryParams) => {
      setQueryParamsBase((prevQueryParams) => {
        if (isFunction(nextQueryParams)) {
          nextQueryParams = nextQueryParams(prevQueryParams);
        }
        if (isEqual(prevQueryParams, nextQueryParams)) {
          return prevQueryParams;
        }
        return nextQueryParams;
      });
      console.log('DeliveriesUIProvider.setQueryParams', queryParams);
    },
    [queryParams]
  );

  const setCreatedDeliver = useCallback((nextCreatedDeliver) => {
    setCreatedDeliverBase((prevCreatedDeliver) => {
      if (isFunction(nextCreatedDeliver)) {
        nextCreatedDeliver = nextCreatedDeliver(prevCreatedDeliver);
      }
      if (isEqual(prevCreatedDeliver, nextCreatedDeliver)) {
        return prevCreatedDeliver;
      }
      return nextCreatedDeliver;
    });
  }, []);

  const setDeliverForView = useCallback((nextDeliverForView) => {
    setDeliverForViewBase((prevDeliverForView) => {
      if (isFunction(nextDeliverForView)) {
        nextDeliverForView = nextDeliverForView(prevDeliverForView);
      }
      if (isEqual(prevDeliverForView, nextDeliverForView)) {
        return prevDeliverForView;
      }
      return nextDeliverForView;
    });
  }, []);

  const value = {
    queryParams,
    createdDeliver,
    deliverForView,
    setQueryParams,
    setCreatedDeliver,
    setDeliverForView,
    initialDeliver,
    openViewDeliverDialog: DeliveriesUIEvents.openViewDeliverDialog,
    openCreateDeliverDialog: DeliveriesUIEvents.openCreateDeliverDialog,
    openDeleteDeliverDialog: DeliveriesUIEvents.openDeleteDeliverDialog,
  };

  return (
    <DeliveriesUIContext.Provider value={value}>
      {children}
    </DeliveriesUIContext.Provider>
  );
}
